declare const LIVE_RELOAD: boolean;
if (LIVE_RELOAD) {
    new EventSource('/esbuild').addEventListener('change', () => location.reload());
}
